module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "href": "https://evolvedpub.com/newsletter/",
      "target": "_blank"
    }
  }, [_vm._v("Evolved Publishing Newsletter")])]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("("), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("NOTA:")]), _vm._v(" Le Newsletter sono in inglese).")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_vm._v("(ENGLISH VERSION)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("LIFE ON DIRT")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Dirt and Stars – Book 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Copyright © 2017 Kevin Killiany")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("La vita a terra")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Terra e Stelle – Libro 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Copyright © 2022 Kevin Killiany")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Traduzione Italiana di Carmelo Massimo Tidona")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Editor: Philip A. Lee")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Artista di copertina: D. Robert Pease")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Interior Designer: Lane Diamond")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("N")]), _vm._v("OTA DELL’EDITORE:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Alla fine di questo romanzo di circa 86.141 parole, troverai una Speciale Anteprima di "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold"
    }
  }, [_vm._v("Alzarsi da terra")]), _vm._v(", il terzo romanzo di Kevin Killiany della serie “Terra e Stelle”. Te la diamo come un servizio extra "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold"
    }
  }, [_vm._v("GRATUITO")]), _vm._v(" e non dovresti in nessun modo considerarla parte del prezzo che hai pagato per questo libro. Speriamo che apprezzerai e ti godrai questa opportunità. Grazie.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-n"
  }, [_vm._v("N")]), _vm._v("ote di licenza per")]), _vm._v(" l’eBook:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Non è consentito utilizzare, riprodurre o trasmettere in qualunque modo nessuna porzione di questo libro senza un’autorizzazione scritta, fatta eccezione per brevi citazioni usate in articoli critici e recensioni, o in base alle leggi di libero utilizzo. Tutti i diritti sono riservati.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questo eBook è licenziato solo per uso personale; non può essere rivenduto o ceduto a terzi. In caso si voglia condividere questo libro con altre persone, si prega di acquistarne un’ulteriore copia per ogni destinatario. Se state leggendo questo libro senza averlo acquistato o senza che sia stato acquistato per il vostro uso personale, vi preghiamo di restituirlo al venditore e acquistarne una copia privata. Grazie per il rispetto del duro lavoro dell’autore.")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-d"
  }, [_vm._v("D")]), _vm._v("isclaimer:")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questa è un’opera di fantasia. Nomi, personaggi, luoghi ed eventi sono il prodotto dell’immaginazione dell’autore o sono usati in maniera fittizia.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0